import { Component, OnInit } from '@angular/core';
import { ServicoService } from 'src/app/services/servico.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { Agencia } from 'src/app/model/agencia.model';
import { TipoServico } from 'src/app/model/tiposervicos.model';
import { Servico } from 'src/app/model/servico.model';
import { Router } from '@angular/router';
import { Usuario } from 'src/app/model/usuario.model';
import { Agendamento } from 'src/app/model/agendamento.model';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CustomSiteService } from '../../services/customsite.service';
import { NotificationsService } from "angular2-notifications";
import * as bowser from 'bowser';

@Component({
  selector: 'app-servico',
  templateUrl: './servico.component.html',
  styleUrls: ['./servico.component.css']
})
export class ServicoComponent implements OnInit {

  usuario: Usuario;
  agencias: Agencia[];
  agenciaSelecionada: Number;
  tipoServicos: TipoServico[];
  tipoServicoSelecionado: Number;
  servicos: Servico[];
  servicoSelecionado: any;
  showSpinner = false;
  cpf;
  abertos: Agendamento[] = [];
  abertosServicoSelecionado: Agendamento[];
  pageTitle = "Atendimento - Pagmob";

  constructor(private router: Router, private configurationService: ConfigurationService, private servicoService: ServicoService, public googleAnalyticsService: GoogleAnalyticsService, private customSiteService: CustomSiteService, private _notificationService: NotificationsService) { }

  ngOnInit() {
    this.showSpinner = true;
    this.googleAnalyticsService.eventEmitter("escolha-servico", "load", "page-load", 1);
    this.usuario = <Usuario>JSON.parse(localStorage.getItem('usuario'))
    let config = this.configurationService.loadConfigurations()
    config.subscribe(result => {
      this.agenciaSelecionada = result.agencyId;
      this.alterarServico();
      this.abertos = JSON.parse(sessionStorage.getItem("agendamentos"));
      const pageTitle = sessionStorage.getItem("pageTitle");
      if (pageTitle == null)
        this.customSiteService.login(config.agencyId).subscribe(customsite => {
          if (customsite.pageTitle) {
            this.pageTitle = customsite.pageTitle;
            sessionStorage.setItem("pageTitle", this.pageTitle);
          }
          if (customsite.pageTitle) sessionStorage.setItem("loginText", customsite.loginText);
          if (customsite.loginObs) sessionStorage.setItem("loginObs", customsite.loginObs);
          if (customsite.popUp) sessionStorage.setItem("popUp", customsite.popUp);
          if (customsite.privacy) sessionStorage.setItem("privacy", customsite.privacy);
          if (customsite.termsAcceptance) sessionStorage.setItem("termsAcceptance", customsite.termsAcceptance);
          if (customsite.register) sessionStorage.setItem("register", customsite.register);
        });
      else {
        this.pageTitle = pageTitle;
      }
    });
  }

  alterarServico() {
    this.showSpinner = true;
    this.servicoSelecionado = null;
    this.servicoService.getTipoServicos(this.agenciaSelecionada).subscribe((result: TipoServico[]) => {
      this.showSpinner = false;
      this.tipoServicos = result;
      if (this.tipoServicos.length == 1) {
        this.tipoServicoSelecionado = this.tipoServicos[0].id;
        this.alterarTipoServico();
      }
    }, (err) => { this.showSpinner = false; });
  }

  alterarTipoServico() {
    this.abertosServicoSelecionado = undefined;
    this.showSpinner = true;
    this.servicoSelecionado = null;
    this.servicoService.getServicos(this.agenciaSelecionada, this.tipoServicoSelecionado, this.usuario.empresa).subscribe((result: Servico[]) => {
      this.showSpinner = false;
      this.servicos = result.sort((a, b) => a.serviceName > b.serviceName ? 1 : -1);

      if (this.servicos != null) {
        if (this.servicos.length === 1) {
          this.servicoSelecionado = this.servicos[0];
          // this.alterarTipoServico();
        }
      } else {
        this.servicos = [];
      }
    }, (err) => { this.showSpinner = false; });
  }

  selecionarServico(servico) {
    this.abertosServicoSelecionado = this.abertos.filter(a => a.serviceId == servico.id);
    this.servicoSelecionado = servico;
    this.servicoSelecionado.serviceTypeList = servico.serviceTypeList.filter(x => x.id == this.tipoServicoSelecionado);
  }

  avancar() {
    const model = { 'agenciaId': this.agenciaSelecionada, 'servico': this.servicoSelecionado };
    const browserInfo = bowser.parse(navigator.userAgent);
    
    const browserName = browserInfo.browser.name.toLowerCase();
    const isSafari = browserName.includes('safari');
    if (isSafari) {
      model.servico.requiredDocs.forEach(doc => {
        delete doc.imageExample;
      });
    }
    try {
      localStorage.setItem('dadosIniciaisAgendamento', JSON.stringify(model));
      this.router.navigate(['/app/agendamento/novo']);
    } catch (error) {
      if (error instanceof DOMException)
        this._notificationService.error('Dados do serviço', 'Solicite ao órgão gestor que verifique os dados do serviço e se as imagens de exemplo são pequenas');
    }
  }
}
